module.exports = __webpack_public_path__ + "media/country_flags/bo-10322784.png";